module.exports = __webpack_public_path__ + "static/media/u_megaphone.4a570978.svg";